import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { CommonModule, CurrencyPipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { DirectivesModule } from "src/app/directives/directives.module";
import { QuestionsModule } from "../questions/questions.module";
import { SharedModule } from "../shared/shared.module";
import { ApgCoverCalculatorComponent } from "./apg-cover-calculator.component";
import { CoverConfirmComponent } from "./cover-confirm/cover-confirm.component";
import { CoverQuestionsComponent } from "./cover-questions/cover-questions.component";
import { CoverResultsComponent } from "./cover-results/cover-results.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DirectivesModule,
    NgxSliderModule,
    CurrencyMaskModule,
    SharedModule,
    QuestionsModule
  ],
  providers: [
    CurrencyPipe
  ],
  exports: [
    ApgCoverCalculatorComponent,
  ],
  declarations: [
    ApgCoverCalculatorComponent,
    CoverQuestionsComponent,
    CoverConfirmComponent,
    CoverResultsComponent
  ]
})
export class ApgCoverCalculatorModule { }
